import React, { Component } from 'react'
import {drawerWidth} from "../config";
import connect from "react-redux/es/connect/connect";
import {withStyles} from "@material-ui/core";
import {logout} from "../actions/authAction";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Menu from "@material-ui/core/Menu/Menu";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import AccountCircle from '@material-ui/icons/AccountCircle';

const styles = theme => ({
    content: {
        marginTop: theme.spacing(1) * 8,
        padding: theme.spacing(1) * 2,
        width: "100%",
    },
    appFrame: {
        zIndex: 1,
        position: 'relative',
        display: 'flex',
        width: '100%',
        minHeight: '100vh',
    },
    appBar: {
        color: '#444',
        background: '#ddd',
        width: `calc(100% - ${drawerWidth}px)`,
    },
    'appBar-left': {
        marginLeft: drawerWidth,
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 20,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {

        position: 'relative',
        width: drawerWidth,
    },
    userMenu: {
        marginLeft: 'auto'

    },
    navMenuFont: {
        fontSize: '14px'
    },
    userMenuController: {
        borderRadius: '0px',
        padding: '8px 12px',
    },
    userMenuDropdown: {
        top: '25px !important',
    }
});


class UserMenuNavBar extends Component {
    state = {
        anchorEl: null | HTMLElement
    };

    constructor(props) {
        super(props);
        this.showButton = this.showButton.bind(this);
        this.handleMenu = this.handleMenu.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.saveState = this.saveState.bind(this);

    }

    showButton(){}

    handleMenu(event: React.MouseEvent<HTMLElement>) {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose(){
        this.setState({ anchorEl: null });
    };

    saveState(){

            try {
                const serializesState = JSON.stringify(this.props.state);
                localStorage.setItem("state", serializesState);
            } catch (err) {
                console.log(err);
            }
    }


    render(){
        const { anchorEl } = this.state;
        const { classes } = this.props;
        const open = Boolean(anchorEl);
        let sButton = null;
        if (this.props.isAuthenticated) {
            //sButton = (<div className={classes.userMenu}><h2></h2> <Button color="inherit" onClick={this.props.logout}>Logout</Button></div>)
            sButton = (
                <div className={classes.userMenu}>
                    <IconButton
                        aria-owns={open ? 'menu-appbar' : undefined}
                        aria-haspopup="true"
                        onClick={this.handleMenu}
                        color="inherit"
                        className={classes.userMenuController}
                    >
                        <AccountCircle /> <a className={classes.navMenuFont}>{this.props.name}</a>
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={open}
                        onClose={this.handleClose}
                        className={classes.userMenuDropdown}
                    >
                        {/*<MenuItem>Profile</MenuItem>*/}
                        <MenuItem onClick={this.saveState}>Save State</MenuItem>
                        <MenuItem onClick={this.props.logout}>Logout</MenuItem>
                    </Menu>
                </div>)
        }

       return (
           <React.Fragment>
               {
                  sButton
               }
           </React.Fragment>
       )
    }
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.id !== null && state.auth.id !== "",
        userId : state.auth.userId,
        name: state.auth.name,
        auth: state.auth,
        state: state
    }
}

export default connect(mapStateToProps, {logout})(withStyles(styles, {withThem: true})(UserMenuNavBar))
